import { Grid } from "@mui/material";
import { Fragment } from "react";
import useDelayUnmount from "../../../hooks/useDelayUnmount";
import classes from "./Loading.module.css";

const Loading = ({ isLoading, children, loadingXS, loadingSM, loadingMD }) => {
  const showLoading = useDelayUnmount(isLoading, 350);

  return (
    <Grid
      container
      item
      xs={loadingXS || 11.2}
      sm={loadingSM || 10.5}
      md={loadingMD || 10}
      sx={{ margin: "auto", pt: { lg: 2, xl: 3 } }}
    >
      {showLoading ? (
        <Grid
          container
          item
          xs={12}
          className={isLoading ? classes.mountedLoading : classes.unmountedLoading}
        >
          <div id="loadingContainer" className={classes.spinnerBackdrop}>
            <h2>لطفا منتظر بمانید</h2>
            <h3>درحال انجام عملیات ...</h3>
            <div className={classes.spinnerContainer}>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </Grid>
      ) : (
        children
      )}
      {/* {showLoading ? (
        <Grid
          container
          item
          xs={12}
          className={isLoading ? classes.mountedLoading : classes.unmountedLoading}
        >
          <div className={classes.spinnerBackdrop}>
            <h2>لطفا منتظر بمانید</h2>
            <h3>درحال انجام عملیات ...</h3>
            <div className={classes.spinnerContainer}>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </Grid>
      ) : null}
      {showLoading ? null : (
        <Grid
          container
          item
          xs={12}
          className={isLoading ? classes.unmountedChildren : classes.mountedChildren}
        >
          {children}
        </Grid>
      )} */}
    </Grid>
  );
};

export default Loading;
